import { cn } from '../../utils/cn.js';

export default function FormCard({ children, className = '' }) {
  return (
    <div
      className={cn(
        'grid grid-cols-1 gap-6 p-0 shadow-none md:rounded-lg md:border md:border-muted-foreground/35 md:bg-muted/35 md:p-10 md:shadow-sm lg:grid-cols-2',
        className,
      )}
    >
      {children}
    </div>
  );
}
